import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { customTableHelpers } from "./customTableHelpers";
import "./customTable.css";
import Stack from "@mui/material/Stack";
import TablePagination from "@mui/material/TablePagination";
import {
  Link,
  // useLocation,
  // useNavigate,
  useSearchParams,
} from "react-router-dom";
import { WebsiteWithUuid } from "../../data/website/Website";
import { pageBuildingEndPointLogic } from "../../logic/AssetManagement/PageManagement/PageBuilding/pageBuildingEndPointLogic";
import { selectUserData, setIsLoading } from "../../features/userSlice";
import { createPageEndPointLogic } from "../../logic/AssetManagement/PageManagement/CreatePage/createPageEndPointLogic";
import Tooltip from "@mui/material/Tooltip";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LightbulbCircleOutlinedIcon from "@mui/icons-material/LightbulbCircleOutlined";
import EditPageMeta from "./EditPageMeta";
import AssignPageGroup from "../AssetManagement/PageBuilder/AssignPageGroup/AssignPageGroup";
import { sitePageEndPointLogic } from "../../logic/AssetManagement/PageManagement/SitePages/sitePagesEndPointLogic";
import store from "../../store";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSelector, useDispatch } from "react-redux";
import {
  selectSelectedDate,
  selectSelectedOptionGroup,
  selectSelectedOptionStatus,
  setPageActionTrigger,
  setSelectedPage,
  setSelectedAssignGroupPages,
  setPageDetails,
} from "../../features/assetManagementSlice";
import { CheckPermissions } from "../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { KeywordDetailsPopup } from "./KeywordDetailsPopup";
import { formatDate } from "../../utils/helpers";

export interface CustomTableProps {
  sitePages: any;
  headCells: any;
  selectedPage: string | undefined;
  selectedSite: WebsiteWithUuid;
  oauthTokenHeader: string;
  siteUid: string;
  duplicatePageResponse: any;
  setDuplicatePageResponse: any[];
  deletePageData: any;
  setDeletePageData: any;
  selectedOptionEdit: string;
  selectedPageOwners: string[];
  searchText: any;
  setSearchText: any;
  setIsAssignPageGroupOpen: any;
  setIsAssignPageGroupEnable: any;
  // setPageDetails: any;
  // setIsCheckboxCheckedArray: any;
  // isCheckboxCheckedArray: any;
  assignPageGroup: any;
  // pageGroupForAssign: any;
  pageGroups: any;
  // pageDetails: any;
  // assignPageGroupDialogOpen: any;
  // setAssignPageGroupDialogOpen: any;
  setIsMetaUpdated: any;
  isMetaUpdated: any;
}
export default function CustomTable({
  headCells,
  selectedPage,
  sitePages,
  selectedSite,
  oauthTokenHeader,
  siteUid,
  duplicatePageResponse,
  setDuplicatePageResponse,
  setDeletePageData,
  selectedOptionEdit,
  // selectedOptionStatus,
  selectedPageOwners,
  searchText,
  setIsAssignPageGroupEnable,
  // setPageDetails,
  // setIsCheckboxCheckedArray,
  // isCheckboxCheckedArray,
  assignPageGroup,
  // pageGroupForAssign,
  // pageGroups,
  // pageDetails,
  // assignPageGroupDialogOpen,
  // setAssignPageGroupDialogOpen,
  setIsMetaUpdated,
}: CustomTableProps) {
  const reloadJavaScriptAndCSS = (page: any) => {
    store.dispatch(setSelectedPage(page));
  };
  const dispatch = useDispatch();
  const userData = useSelector(selectUserData);
  const originalSitePages = useMemo(() => {
    return sitePages || [];
  }, [sitePages]);

  const siteURL = selectedSite && Object.values(selectedSite)[0].site_url;
  const [rows, setRows] = useState(
    originalSitePages ? originalSitePages : null
  );
  const infoKeys = ["total_click_in", "total_ftd", "keyword_count"];
  const infoText = "  from Paid Traffic in the last 30 Days";
  const [page, setPage] = useState(sitePages?.page - 1 || 0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false);
  const [selectedPageToDelete, setSelectedPageToDelete] = useState([]) as any;
  const [selectedPageToDuplicate, setSelectedPageToDuplicate] = useState(
    []
  ) as any;
  const [pageContent, setPageContent] = useState([]);
  const [pageTitle, setPageTitle] = useState<string>();
  const [openDuplicateDialogBox, setOpenDuplicateDialogBox] = useState(false);
  const [keywordPopupOpen, setKeywordPopupOpen] = useState(false);
  const [selectedKeywordData, setSelectedKeywordData] = useState<any>(null);
  const selectedOptionStatus = useSelector(selectSelectedOptionStatus);
  const selectedDate = useSelector(selectSelectedDate);
  const { selectedAssignGroupPages, pageDetails } = useSelector(
    (state: any) => state.assetManagement
  );
  const hasViewPageContentPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "view_page_content"
  );
  const hasEditPagesMetaPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "edit_pages_meta"
  );

  const hasDeletePagesPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "delete_pages"
  );
  const hasDuplicatePagesPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "page_management",
    "duplicate_pages"
  );
  // const [, setErrorAccToPageStatus] = useState(false);
  // const [, setRetry] = useState(false);
  // const [, setOpen] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage); // Assuming you have a state for the current page
    dispatch(setPageDetails([]));
    dispatch(setSelectedAssignGroupPages([]));
   
    // Preserve existing params while updating "page"
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", String(newPage)); // Store as 1-based index in the URL
    setSearchParams(newParams);
  };

  useEffect(() => {
    const pageFromParams = searchParams.get("page");
    if (pageFromParams) {
      setPage(Number(pageFromParams)); // Convert 1-based index to 0-based index
    }
  }, [searchParams]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    dispatch(setPageDetails([]));
    dispatch(setSelectedAssignGroupPages([]));
  };
  // const handleCheckboxChange = (index: number, page: any) => {
  //   const updatedCheckboxState = [...isCheckboxCheckedArray];
  //   updatedCheckboxState[index] = !updatedCheckboxState[index];
  //   setIsCheckboxCheckedArray(updatedCheckboxState);
  //   setPageDetails((prevDetails: any) => {
  //     const exists = prevDetails.some((detail: any) => detail.id === page.id);
  //     const pageWithIndex = { ...page, index };
  //     if (exists) {
  //       return prevDetails.filter((detail: any) => detail.id !== page.id);
  //     } else {
  //       return [...prevDetails, pageWithIndex];
  //     }
  //   });
  // };


  const handleCheckboxChange = (row: any) => {
    const isSelected = pageDetails.some((item: any) => item.id === row.id);
    if (isSelected) {
      // Uncheck → remove from both
      dispatch(
        setPageDetails(pageDetails.filter((item: any) => item.id !== row.id))
      );
      dispatch(
        setSelectedAssignGroupPages(
          selectedAssignGroupPages.filter((item: any) => item.id !== row.id)
        )
      );
    } else {
      // Check → add to both
      dispatch(setPageDetails([...pageDetails, row]));
      dispatch(setSelectedAssignGroupPages([...selectedAssignGroupPages, row]));
    }
  };

  // Handles selecting/deselecting all rows on the current page
  // --- Handles selecting/deselecting all rows on the current page ---
  const handleHeaderCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;

    // Get only rows visible on the current page (filtered & paginated)
    const currentPageRows = filteredRows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    if (isChecked) {
      // Merge current page rows into existing selected ones, avoiding duplicates
      const merged = [
        ...pageDetails,
        ...currentPageRows.filter(
          (row: any) => !pageDetails.some((r: any) => r.id === row.id)
        ),
      ];

      dispatch(setPageDetails(merged));
      dispatch(setSelectedAssignGroupPages(merged));
     
    } else {
      // Remove only current page rows from the selected states
      const remaining = pageDetails.filter(
        (r: any) => !currentPageRows.some((p: any) => p.id === r.id)
      );

      dispatch(setPageDetails(remaining));
      dispatch(setSelectedAssignGroupPages(remaining));
    }
  };

  // --- Handle global header checkbox ---
  // const handleHeaderCheckboxChange = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const isChecked = event.target.checked;

  //   // Rows visible on the current page only (filtered & paginated)
  //   const paginatedRows = sortedRows
  //     .filter(
  //       (row: any) => row.shared_uid !== null && row?.post_status !== "bin"
  //     )
  //     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  //   if (isChecked) {
  //     // Merge paginated rows into existing selected ones (avoid duplicates)
  //     const merged = [
  //       ...pageDetails,
  //       ...paginatedRows.filter(
  //         (row: any) =>
  //           !pageDetails.some(
  //             (existing: any) => existing.shared_uid === row.shared_uid
  //           )
  //       ),
  //     ];
  //     dispatch(setPageDetails(merged));
  //     dispatch(setSelectedAssignGroupPages(merged));
  //   } else {
  //     // Remove only the rows from the current page
  //     const remaining = pageDetails.filter(
  //       (r: any) =>
  //         !paginatedRows.some((p: any) => p.shared_uid === r.shared_uid)
  //     );
  //     dispatch(setPageDetails(remaining));
  //     dispatch(setSelectedAssignGroupPages(remaining));
  //   }
  // };

  const handleKeywordClick = (page: any) => {
    setSelectedKeywordData(page?.queryData?.rawQueries);
    setKeywordPopupOpen(true);
  };

  useEffect(() => {
    if (selectedPage) {
      const searchedResult = customTableHelpers.requestSearch(
        selectedPage,
        originalSitePages
      );
      setRows(searchedResult);
      // setPage(0);
    } else {
      setRows(originalSitePages);
    }
    // eslint-disable-next-line
  }, [selectedPage]);
  useEffect(() => {
    setRows(originalSitePages);
    // setPage(0);
  }, [siteURL, originalSitePages, duplicatePageResponse]);

  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const [isDuplicateConfirmationOpen, setIsDuplicateConfirmationOpen] =
    useState(false);

  const [showDuplicateErrorDialog, setShowDuplicateErrorDialog] =
    useState(false);
  const [, setIsDuplicateSuccessful] = useState(false);
  const [editPageMetaOpen, setEditPageMetaOpen] = useState(false);
  // states for editing page meta
  const [singlePageTitle, setSinglePageTitle] = useState<string>();
  const [pageStatus, setPageStatus] = useState(null);
  const [pageType, setPageType] = useState(null);
  const [pageUid, setPageUid] = useState(null);
  const selectedOptionGroup = useSelector(selectSelectedOptionGroup);

  const uniquePostStatuses = originalSitePages.reduce(
    (acc: string[], item: any) => {
      if (item.post_status !== "pending" && !acc.includes(item.post_status)) {
        acc.push(item.post_status);
      }
      return acc;
    },
    ["publish", "bin", "draft", "pending"]
  );

  const uniquePostTypes = originalSitePages.reduce(
    (acc: string[], item: any) => {
      if (!acc.includes(item.post_type)) {
        acc.push(item.post_type);
      }
      return acc;
    },
    []
  );

  const data = {
    data: {
      post_title: `${pageTitle}`,
    },
  };

  // State to manage the sorting key and direction
  const [sort, setSort] = useState<{
    keytoSort: string | undefined;
    direction: "asc" | "desc" | undefined;
  }>({ keytoSort: undefined, direction: undefined });

  // Headers for the table columns with id, KEY for sorting, and LABEL for display
  const tableheaders = [
    { id: 1, KEY: "post_name", LABEL: "Name", sortable: true },
    { id: 2, KEY: "post_status", LABEL: "Status", sortable: true },
    { id: 3, KEY: "total_click_in", LABEL: "Clicks", sortable: true },
    { id: 4, KEY: "total_ftd", LABEL: "Conversions", sortable: true },
    { id: 5, KEY: "keyword_count", LABEL: "Leading Keywords", sortable: true },
    { id: 6, KEY: "page_group_name", LABEL: "Group", sortable: true },
    { id: 7, KEY: "modified_date", LABEL: "Date", sortable: true },
    { id: 8, KEY: "post_id", LABEL: "Page Id", sortable: true },
    { id: 9, KEY: "Actions", LABEL: "Quick Actions", sortable: false },
  ];

  // Function to handle click on table headers
  function handleHeaderClick(header: any) {
    if (!header.sortable) return; // Ignore click if column is not sortable

    setSort({
      keytoSort: header.KEY,
      // Toggle sort direction if the same column is clicked, otherwise default to ascending
      direction:
        header.KEY === sort.keytoSort && sort.direction === "asc"
          ? "desc"
          : "asc",
    });
  }
  // Function to get sorted data based on current sort state
  function getSortedData(arrayToSort: any[]) {
    // If no sorting key is set, return the original array
    if (!sort.keytoSort || !sort.direction) {
      return arrayToSort;
    }

    // Clone the array to avoid mutating the original array
    return arrayToSort.slice().sort((a, b) => {
      // Check if sort.keytoSort is not undefined and has the property
      const keytoSort = sort.keytoSort;

      if (keytoSort === undefined) {
        return 0; // Return 0 if the sorting key is undefined
      }

      const aValue = a[keytoSort];
      const bValue = b[keytoSort];

      // Handle undefined values for sorting
      if (aValue === undefined) {
        return 1; // Move undefined values to the end
      }
      if (bValue === undefined) {
        return -1; // Move undefined values to the end
      }

      // Handle "N/A" values for sorting
      if (aValue === "") {
        return 1; // Move "N/A" values to the end
      }
      if (bValue === "") {
        return -1; // Move "N/A" values to the end
      }

      // Perform sorting based on the direction and type of values
      if (typeof aValue === "string" && typeof bValue === "string") {
        // String comparison (localeCompare for correct string sorting)
        return sort.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      } else if (typeof aValue === "number" && typeof bValue === "number") {
        // Numeric comparison
        return sort.direction === "asc" ? aValue - bValue : bValue - aValue;
      } else if (aValue instanceof Date && bValue instanceof Date) {
        // Date comparison
        return sort.direction === "asc"
          ? aValue.getTime() - bValue.getTime()
          : bValue.getTime() - aValue.getTime();
      } else {
        // Fallback to string comparison if values are of different types
        return sort.direction === "asc"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    });
  }
  const sortedRows = getSortedData(rows || []); // Use getSortedData to sort the rows

  // Filter the data based on the selected options

  useEffect(() => {
    const filteredData = sitePages
      ?.filter((option: any) => {
        // Date filtering logic (keep as is)
        const isDateInRange =
          selectedDate.length === 2 && selectedDate[0] && selectedDate[1]
            ? selectedDate[0] === selectedDate[1]
              ? new Date(option?.modified_date).toDateString() ===
                new Date(selectedDate[0]).toDateString()
              : new Date(option?.modified_date) >= new Date(selectedDate[0]) &&
                new Date(option?.modified_date) <=
                  new Date(new Date(selectedDate[1]).setHours(23, 59, 59, 999))
            : true;

        // Improved search logic
        const searchMatch =
          !searchText.trim() ||
          option?.post_title
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          option?.post_name?.toLowerCase().includes(searchText.toLowerCase());

        return (
          searchMatch &&
          (!selectedOptionGroup.length ||
            selectedOptionGroup.includes(option?.page_group_name)) &&
          (!selectedOptionEdit.length ||
            selectedOptionEdit.includes(option?.modified_by)) &&
          (!selectedOptionStatus.length ||
            selectedOptionStatus.includes(option?.post_status)) &&
          (!selectedPageOwners.length ||
            selectedPageOwners.includes(option?.modified_by)) &&
          isDateInRange
        );
      })
      .map((option: any, index: any) => ({
        id: index + 1,
        post_name: option?.post_name,
        page_group_name: option?.page_group_name ? option?.page_group_name : "",
        post_id: option?.post_id ? option?.post_id : "",
        modified_date: option?.modified_date ? option?.modified_date : "",
        post_status: option?.post_status ? option?.post_status : "",
        shared_uid: option?.shared_uid,
        total_click_in: option?.queryData?.total_click_in || 0,
        total_click_out: option?.queryData?.total_click_out || 0,
        total_ftd: option?.queryData?.total_ftd || 0,
        keyword_count: option?.queryData?.keyword_count || 0,
        ...option,
      }));
    setRows(filteredData);
    dispatch(setSelectedAssignGroupPages([]));
    // setIsCheckboxCheckedArray(new Array(filteredData.length).fill(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sitePages,
    selectedOptionGroup,
    selectedDate,
    selectedOptionEdit,
    selectedOptionStatus,
    selectedPageOwners,
    // setIsCheckboxCheckedArray,
    searchText, // Make sure searchText is in dependencies
  ]);
  // Update the filtered data when the selected options change

  // useEffect(() => {
  //   // setIsCheckboxCheckedArray([]);
  //   // setPageDetails([]);
  //   // eslint-disable-next-line
  // }, [page]);

  // Function to open confirmation dialog
  const openDeleteConfirmation = (page: any) => {
    setSelectedPageToDelete(page);
    setIsDeleteConfirmationOpen(true);
  };

  const openDuplicateConfirmation = async (page: any) => {
    setSelectedPageToDuplicate(page);
    setIsDuplicateConfirmationOpen(true);
    setPageTitle(`${page?.post_title}-copy`);
  };

  // Function to close confirmation dialog
  const closeDeleteConfirmation = () => {
    setIsDeleteConfirmationOpen(false);
    setIsDuplicateConfirmationOpen(false);
  };

  const deletePage = async () => {
    try {
      // Perform data fetching for
      await pageBuildingEndPointLogic.deletePage(
        siteUid,
        selectedPageToDelete?.shared_uid,
        oauthTokenHeader,
        setIsLoading,
        setDeletePageData
      );
      store.dispatch(setPageActionTrigger((prev: any) => prev + 1));
    } catch (error) {
      // Handle errors
      console.error("Error Deleting Accounts:", error);
    }
  };

  // useEffect(() => {
  //   const trueCount = Array.isArray(isCheckboxCheckedArray)
  //     ? isCheckboxCheckedArray.filter((value) => value === true).length
  //     : [];
  //   if (trueCount !== 0) {
  //     setIsAssignPageGroupEnable(false);
  //   } else {
  //     setIsAssignPageGroupEnable(true);
  //   }
  // }, [setIsAssignPageGroupEnable, isCheckboxCheckedArray]);

  useEffect(() => {
    // If there are selected rows, disable; otherwise enable
    if (pageDetails.length > 0) {
      setIsAssignPageGroupEnable(false);
    } else {
      setIsAssignPageGroupEnable(true);
    }
  // eslint-disable-next-line
  }, [pageDetails]);

  // Function to handle deletion
  const handleDelete = async () => {
    setIsDeleteConfirmationOpen(false);
    try {
      store.dispatch(setIsLoading(true));
      await deletePage();
      closeDeleteConfirmation();
    } catch (error) {
      // Handle errors
      console.error("Error deleting page:", error);
    }
  };

  //Function to dupliacate the page
  const duplicatePage = async () => {
    try {
      await createPageEndPointLogic.duplicatePage(
        searchParams.get("selectedSite") as any,
        data,
        setIsLoading,
        oauthTokenHeader,
        setDuplicatePageResponse,
        selectedPageToDuplicate?.shared_uid,
        setShowDuplicateErrorDialog
      );
      store.dispatch(setPageActionTrigger((prev: any) => prev + 1));
    } catch (error) {
      console.error("Error fetching page content:", error);
    }
  };

  const handleRetryDuplicate = () => {
    setShowDuplicateErrorDialog(false); // Close the error dialog
    setOpenDuplicateDialogBox(true); // Open the duplicate page dialog again
  };

  const handleCloseDuplicateDialogBox = () => {
    setOpenDuplicateDialogBox(false);
  };

  const handleDuplicate = () => {
    setIsDuplicateConfirmationOpen(false); // Close the duplicate confirmation dialog
    setOpenDuplicateDialogBox(true); // Open the duplicate page dialog
  };

  const validate = async () => {
    if (!pageTitle) {
      console.error("Missing Mandatory Fields");
    } else {
      setOpenDuplicateDialogBox(false); // Close the duplicate page dialog
      try {
        setIsLoading(true);
        await duplicatePage();
        closeDeleteConfirmation(); // Close any delete confirmation dialogs
        setIsDuplicateSuccessful(true); // Set state to indicate successful duplication
      } catch (error) {
        // Handle error scenarios
        setShowDuplicateErrorDialog(true); // Show error dialog for duplicate page title
      } finally {
        setIsLoading(false);
      }
    }
  };

  const filteredRows = useMemo(
    () =>
      sortedRows.filter(
        (row) => row.shared_uid !== null && row?.post_status !== "bin"
      ),
    [sortedRows]
  );

  const paginatedRows = useMemo(() => {
    const start = page * rowsPerPage;
    return filteredRows.slice(start, start + rowsPerPage);
  }, [filteredRows, page, rowsPerPage]);

  // function formatDate(dateString: any) {
  //   if (!dateString) return "";

  //   // Split the date and time parts
  //   const [datePart, timePart] = dateString.split(" ");

  //   // Parse the date part
  //   const date = new Date(datePart);

  //   // Extract day, month, and year
  //   const day = String(date.getDate()).padStart(2, "0"); // Ensures two digits
  //   const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  //   const year = date.getFullYear();

  //   // Return formatted date with time
  //   return `${day}-${month}-${year} ${timePart}`;
  // }

  const handleTuneIconClick = async (page: any) => {
    await sitePageEndPointLogic.getPageContent(
      siteUid,
      page?.shared_uid,
      oauthTokenHeader,
      setPageContent,
      setIsLoading
    );
    setEditPageMetaOpen(true);
    setSinglePageTitle(page?.post_title);
    setPageType(page?.post_type);
    setPageStatus(page?.post_status);
    setPageUid(page?.shared_uid);
  };

  // Preserve existing query params while adding selectedPage
  const newParams = new URLSearchParams(searchParams);
  const newSearchString = newParams.toString();
  const selectedSharedUid = searchParams.get("selectedSite") as any;

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Grid container item style={{ width: "100%" }}>
            <TableContainer className="pageBuilderTableWrap" component={Paper}>
              <Table aria-label="Page Builder Table">
                <TableHead>
                  <TableRow>
                    {hasEditPagesMetaPermission ? (
                      <>
                        <TableCell sx={{ padding: "0 16px 0 16px" }}>
                          <Checkbox
                            color="secondary"
                            size="small"
                            checked={
                              paginatedRows.length > 0 &&
                              paginatedRows.every((row) =>
                                pageDetails.some(
                                  (selected: any) => selected.id === row.id
                                )
                              )
                            }
                            onChange={handleHeaderCheckboxChange}
                          />
                        </TableCell>
                        {tableheaders.map((header, index) => (
                          <TableCell
                            key={header.id}
                            sx={{
                              padding: index === 0 ? "16px 2px" : "default", // Change padding for the second cell
                            }}
                          >
                            <TableSortLabel
                              active={sort.keytoSort === header.KEY}
                              direction={
                                sort.keytoSort === header.KEY
                                  ? sort.direction
                                  : "asc"
                              }
                              onClick={() => handleHeaderClick(header)}
                              disabled={!header.sortable}
                            >
                              {header.LABEL}
                              {infoKeys.includes(header.KEY) && (
                                <Tooltip title={header.LABEL + infoText}>
                                  <InfoOutlinedIcon
                                    fontSize="small"
                                    sx={{
                                      ml: 0.5,
                                      verticalAlign: "middle",
                                      color: "grey.600",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </TableSortLabel>
                          </TableCell>
                        ))}
                      </>
                    ) : (
                      tableheaders.map((header, index) => (
                        <TableCell
                          key={header.id}
                          sx={{
                            padding: index === 0 ? "8px 16px" : "default", // Change padding for the second cell
                          }}
                        >
                          <TableSortLabel
                            active={sort.keytoSort === header.KEY}
                            direction={
                              sort.keytoSort === header.KEY
                                ? sort.direction
                                : "asc"
                            }
                            onClick={() => handleHeaderClick(header)}
                            disabled={!header.sortable}
                          >
                            {header.LABEL}
                            {infoKeys.includes(header.KEY) && (
                              <Tooltip title={header.LABEL + infoText}>
                                <InfoOutlinedIcon
                                  fontSize="small"
                                  sx={{
                                    ml: 0.5,
                                    verticalAlign: "middle",
                                    color: "grey.600",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </TableSortLabel>
                        </TableCell>
                      ))
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedRows && sortedRows.length > 0 ? (
                    sortedRows
                      ?.filter(
                        (row) =>
                          row.shared_uid !== null && row?.post_status !== "bin"
                      )
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((page, index) => (
                        <>
                          <TableRow
                            key={index}
                            // className="draggable-dialog-title"
                            hover={true}
                            sx={{ padding: "8px 16px" }}
                            className={
                              pageDetails.some((item: any) => item === page)
                                ? "background"
                                : ""
                            }
                          >
                            <TableCell
                              key={index}
                              className={
                                pageDetails.some((item: any) => item === page)
                                  ? "background"
                                  : ""
                              }
                              sx={{ padding: "0px 0px 0px 16px", width: "0%" }}
                            >
                              <Checkbox
                                key={index}
                                color="secondary"
                                checked={pageDetails.some(
                                  (i: any) => i.id === page.id
                                )}
                                onChange={() => handleCheckboxChange(page)}
                                size="small"
                                sx={{
                                  padding: "9px", // Adjust this value to reduce the padding
                                }}
                              />
                            </TableCell>
                            {Object.keys(headCells)?.map(
                              (headCell, cellIndex) => {
                                if (headCell === "post_name")
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      align="left"
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                      sx={{ padding: "10px 0" }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                      >
                                        {hasViewPageContentPermission ? (
                                          <Tooltip title="Edit" placement="top">
                                            <IconButton data-tracker="16">
                                              <Link
                                                to={{
                                                  pathname:
                                                    "/performance/page_builder/edit",
                                                  search: `?${newSearchString}&selectedPage=${page.shared_uid}`, // Append updated query params
                                                }}
                                                onClick={() =>
                                                  reloadJavaScriptAndCSS(page)
                                                }
                                              >
                                                <EditIcon
                                                  color="secondary"
                                                  fontSize="small"
                                                />
                                              </Link>
                                            </IconButton>
                                          </Tooltip>
                                        ) : (
                                          <Tooltip title="Edit" placement="top">
                                            <IconButton disabled>
                                              <EditIcon color="disabled" />
                                            </IconButton>
                                          </Tooltip>
                                        )}

                                        <Box>
                                          {page[headCell] ? page[headCell] : ""}
                                        </Box>
                                      </Box>
                                    </TableCell>
                                  );
                                else if (headCell === "post_id")
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      align={"left"}
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                    >
                                      <Link
                                        to={`${siteURL}?page_id=${page[headCell]}&nowprocket`}
                                        style={{
                                          textDecoration: "underline",
                                          color: "#9C27B0",
                                        }}
                                        target="_blank"
                                        data-tracker="13"
                                      >
                                        {page[headCell] ? page[headCell] : ""}
                                      </Link>
                                    </TableCell>
                                  );
                                else if (headCell === "page_group_name")
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      align={"left"}
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                    >
                                      {page[headCell] ? (
                                        <Button
                                          onClick={() => {
                                            window.open(
                                              `/operations/page_groups?selectedSite=${selectedSharedUid}&search=${decodeURIComponent(
                                                page[headCell]
                                              )}`,
                                              "_blank"
                                            );
                                          }}
                                          data-tracker="372"
                                          variant="outlined"
                                          size="small"
                                          sx={{
                                            borderRadius: "6px",
                                            borderColor: "#E1BEE7",
                                            color: "#9C27B0",
                                            textTransform: "none",
                                            fontWeight: 500,
                                            fontSize: "12px",
                                            padding: "6px 17px",
                                            lineHeight: 1.5,
                                            "&:hover": {
                                              boxShadow:
                                                "0px 7px 9px rgba(0, 0, 0, 0.15)", // gray shadow
                                              backgroundColor: "transparent",
                                              borderColor: "#E1BEE7",
                                            },
                                          }}
                                        >
                                          {page[headCell]}
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  );
                                else if (headCell === "post_status") {
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                    >
                                      {page[headCell] === "publish" ? (
                                        <Alert
                                          icon={
                                            <CheckCircleOutlineIcon
                                              sx={{
                                                color: "#1E4620",
                                                fontSize: "16px",
                                              }}
                                              fontSize="inherit"
                                            />
                                          }
                                          sx={{
                                            color: "#1E4620",
                                            padding: "0px 4px",
                                            border: "1px solid #2E7D3280",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "left",
                                            textTransform: "capitalize",
                                            height: "26px",
                                            width: "93px",
                                          }}
                                        >
                                          {page[headCell]}
                                        </Alert>
                                      ) : page[headCell] === "draft" ? (
                                        <Alert
                                          icon={
                                            <LightbulbCircleOutlinedIcon
                                              sx={{
                                                color: "#00000099",
                                                fontSize: "16px",
                                              }}
                                              fontSize="small"
                                            />
                                          }
                                          sx={{
                                            color: "#00000099",
                                            padding: "0px 4px",
                                            border: "1px solid #9E9E9E",
                                            background: "#E0E0E0",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "left",
                                            textTransform: "capitalize",
                                            height: "25px",
                                            width: "93px",
                                          }}
                                        >
                                          {page[headCell]}
                                        </Alert>
                                      ) : (
                                        <Alert
                                          icon={
                                            <PendingOutlinedIcon
                                              sx={{
                                                color: "#014361",
                                                fontSize: "16px",
                                              }}
                                              fontSize="inherit"
                                            />
                                          }
                                          sx={{
                                            color: "#014361",
                                            padding: "0px 4px",
                                            border: "1px solid #2196F380",
                                            background: "#E5F6FD",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "left",
                                            textTransform: "capitalize",
                                            height: "25px",
                                            width: "93px",
                                          }}
                                        >
                                          {page[headCell]}
                                        </Alert>
                                      )}
                                    </TableCell>
                                  );
                                } else if (headCell === "modified_date") {
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      align={"left"}
                                      sx={{ padding: "7px 16px" }}
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                    >
                                      <div className="Avatar-head">
                                        {page[headCell]
                                          ? formatDate(page[headCell])
                                          : ""}
                                      </div>
                                    </TableCell>
                                  );
                                } else if (headCell === "Actions")
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      sx={{ padding: 0 }}
                                      align={"left"}
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                    >
                                      {page?.shared_uid ? (
                                        <div className="tablecell10">
                                          <div className="box132">
                                            <div className="stack15">
                                              <div className="instance-115">
                                                {hasEditPagesMetaPermission ? (
                                                  <Tooltip
                                                    title="Meta Update"
                                                    placement="top"
                                                  >
                                                    <TuneIcon
                                                      fontSize="small"
                                                      sx={{ cursor: "pointer" }}
                                                      color="secondary"
                                                      data-tracker="11"
                                                      onClick={() =>
                                                        handleTuneIconClick(
                                                          page
                                                        )
                                                      }
                                                    />
                                                  </Tooltip>
                                                ) : (
                                                  <TuneIcon
                                                    fontSize="small"
                                                    color="disabled"
                                                  />
                                                )}
                                              </div>
                                              <Tooltip
                                                title="Duplicate"
                                                placement="top"
                                              >
                                                {hasDuplicatePagesPermission ? (
                                                  <ContentCopyIcon
                                                    sx={{
                                                      color:
                                                        page.post_status ===
                                                        "pending"
                                                          ? "grey"
                                                          : "secondary.main",
                                                      cursor:
                                                        page.post_status ===
                                                        "pending"
                                                          ? "not-allowed"
                                                          : "pointer",
                                                    }}
                                                    onClick={
                                                      page.post_status !==
                                                      "pending"
                                                        ? () =>
                                                            openDuplicateConfirmation(
                                                              page
                                                            )
                                                        : undefined
                                                    }
                                                    fontSize="small"
                                                    data-tracker="9"
                                                  />
                                                ) : (
                                                  <ContentCopyIcon
                                                    fontSize="small"
                                                    color="disabled"
                                                  />
                                                )}
                                              </Tooltip>
                                              <div className="instance-115">
                                                {hasDeletePagesPermission ? (
                                                  <Tooltip
                                                    title="Delete"
                                                    placement="top"
                                                  >
                                                    <DeleteOutlineIcon
                                                      fontSize="small"
                                                      sx={{ cursor: "pointer" }}
                                                      onClick={() =>
                                                        openDeleteConfirmation(
                                                          page
                                                        )
                                                      }
                                                      color="secondary"
                                                      data-tracker="8"
                                                    />
                                                  </Tooltip>
                                                ) : (
                                                  <Tooltip
                                                    title="Delete"
                                                    placement="top"
                                                  >
                                                    <DeleteOutlineIcon
                                                      color="disabled"
                                                      fontSize="small"
                                                    />
                                                  </Tooltip>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        "Error: No shared_uid for this page"
                                      )}
                                    </TableCell>
                                  );
                                else if (headCell === "total_click_in") {
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      align={"left"}
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                    >
                                      {page[headCell] !== undefined
                                        ? page[headCell]
                                        : ""}
                                    </TableCell>
                                  );
                                } else if (headCell === "total_ftd") {
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      align={"left"}
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                    >
                                      {page[headCell] !== undefined
                                        ? page[headCell]
                                        : ""}
                                    </TableCell>
                                  );
                                } else if (headCell === "keyword_count") {
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      align="left"
                                      className={
                                        pageDetails.some(
                                          (item: any) => item === page
                                        )
                                          ? "background"
                                          : ""
                                      }
                                      sx={
                                        page.keyword_count === 0 ||
                                        page[headCell] === undefined ||
                                        page[headCell] === ""
                                          ? {}
                                          : {
                                              color: "#9C27B0",
                                              cursor: "pointer",
                                              textDecoration: "underline",
                                            }
                                      }
                                      onClick={
                                        page.keyword_count === 0 ||
                                        page[headCell] === undefined ||
                                        page[headCell] === ""
                                          ? undefined
                                          : () => handleKeywordClick(page)
                                      }
                                      data-tracker="436"
                                    >
                                      {page[headCell] !== undefined
                                        ? page[headCell]
                                        : ""}
                                    </TableCell>
                                  );
                                } else return <TableCell>{""}</TableCell>;
                              }
                            )}
                          </TableRow>
                        </>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={tableheaders.length + 1}
                        align="center"
                      >
                        <Typography variant="h6">
                          No Page Names matching. Try selecting from the search
                          field
                        </Typography>{" "}
                        {/* No data available message */}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <Stack
                spacing={1}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <TablePagination
                  component="div"
                  count={
                    sortedRows.filter(
                      (page: any) =>
                        page.shared_uid !== null && page?.post_status !== "bin"
                    ).length
                  }
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[]}
                  sx={{
                    ".css-16c50h-MuiInputBase-root-MuiTablePagination-select,.MuiTablePagination-selectLabel":
                      {
                        display: "none",
                      },
                    ".MuiTablePagination-actions": {
                      display: "none",
                    },
                    ".MuiTablePagination-toolbar": {
                      paddingLeft: "16px",
                    },
                  }}
                />
                <Pagination
                  count={Math.ceil(
                    sortedRows.filter(
                      (page: any) =>
                        page.shared_uid !== null && page?.post_status !== "bin"
                    ).length / rowsPerPage
                  )}
                  page={page + 1} // Convert zero-based index back to 1-based for MUI
                  showFirstButton
                  showLastButton
                  className="pagination-button"
                  color="secondary"
                  size="small"
                  sx={{
                    ".css-wjh20t-MuiPagination-ul": {
                      justifyContent: "center",
                    },
                  }}
                  onChange={(event, value) =>
                    handleChangePage(event, value - 1)
                  }
                />
                <TablePagination
                  component="div"
                  count={
                    originalSitePages.filter(
                      (page: any) =>
                        page.shared_uid !== null && page?.post_status !== "bin"
                    ).length
                  }
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  classes={{
                    displayedRows: "hidden-displayed-rows", // Apply the custom class
                  }}
                  sx={{
                    ".MuiTablePagination-actions": {
                      display: "none",
                    },
                  }}
                />
              </Stack>
            </TableContainer>
            <Dialog
              open={isDeleteConfirmationOpen}
              onClose={closeDeleteConfirmation}
            >
              <DialogTitle>Confirmation of Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete this page?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={closeDeleteConfirmation} color="secondary">
                  No
                </Button>
                <Button
                  onClick={handleDelete}
                  color="secondary"
                  style={{ backgroundColor: "#9C27B0", color: "white" }}
                  data-tracker="8"
                >
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={isDuplicateConfirmationOpen}
              onClose={closeDeleteConfirmation}
            >
              <DialogTitle>Confirmation of Duplicate</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to duplicate this page?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={closeDeleteConfirmation} color="secondary">
                  No
                </Button>
                <Button
                  onClick={handleDuplicate}
                  color="secondary"
                  style={{ backgroundColor: "#9C27B0", color: "white" }}
                  data-tracker="10"
                >
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openDuplicateDialogBox} fullWidth maxWidth="md">
              <div
                style={{
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
                  Duplicate Page
                </DialogTitle>
                {/* {errorValidate ? <Alert severity="warning" sx={{marginBottom:"10px"}} >{errorValidate}</Alert> : "" } */}
                <div
                  style={{ marginBottom: "20px", display: "flex", gap: "20px" }}
                >
                  <div style={{ flex: 1 }}>
                    <TextField
                      required
                      fullWidth
                      id="pageTitle"
                      label="Page Title"
                      value={pageTitle}
                      onChange={(e) => setPageTitle(e.target.value)}
                    />
                  </div>
                </div>
                <Box
                  component="div"
                  sx={{
                    p: 1,
                    borderRadius: 1,
                    backgroundColor: "#F7EEF9",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <InfoOutlinedIcon
                      style={{ marginRight: "8px" }}
                      color="secondary"
                    />
                    <Typography variant="h6" color="#9C27B0">
                      PLEASE NOTE:
                    </Typography>
                  </div>
                  <Typography color="#9C27B0" sx={{ paddingLeft: 5 }}>
                    All pages are duplicated with either a "Publish" or "Draft"
                    status.
                  </Typography>
                </Box>
              </div>
              <DialogActions>
                <Button
                  onClick={handleCloseDuplicateDialogBox}
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => validate()}
                  variant="contained"
                  color="secondary"
                  endIcon={<AutoFixHighIcon />}
                  data-tracker="10"
                >
                  Duplicate
                </Button>
              </DialogActions>
            </Dialog>
            {/* Assign page group Dialog */}
            <AssignPageGroup
              // isCheckboxCheckedArray={isCheckboxCheckedArray}
              // setIsCheckboxCheckedArray={setIsCheckboxCheckedArray}
              // setRefresh={setIsMetaUpdated}
              // setPageDetails={setPageDetails}
              assignPageGroup={assignPageGroup}
              // pageGroupForAssign={pageGroupForAssign}
              // pageGroups={pageGroups}
              // pageDetails={pageDetails}
              // assignPageGroupDialogOpen={assignPageGroupDialogOpen}
              // setAssignPageGroupDialogOpen={setAssignPageGroupDialogOpen}
            />
            <KeywordDetailsPopup
              open={keywordPopupOpen}
              onClose={() => setKeywordPopupOpen(false)}
              keywordData={selectedKeywordData}
            />
            {/* Duplicate Error Dialog */}
            <Dialog
              open={showDuplicateErrorDialog}
              onClose={() => setShowDuplicateErrorDialog(false)}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>Duplicate Page Title</DialogTitle>
              <DialogContent>
                <Typography>
                  A page with this title already exists or there was an error
                  while duplicating the page. Do you want to retry?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setShowDuplicateErrorDialog(false)}
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleRetryDuplicate}
                  color="secondary"
                  variant="contained"
                >
                  Retry
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
      </Grid>
      {
        <EditPageMeta
          editPageMetaOpen={editPageMetaOpen}
          setEditPageMetaOpen={setEditPageMetaOpen}
          uniquePostStatuses={uniquePostStatuses}
          uniquePostTypes={uniquePostTypes}
          singlePageTitle={singlePageTitle}
          setSinglePageTitle={setSinglePageTitle}
          setPageStatus={setPageStatus}
          pageStatus={pageStatus}
          setPageType={setPageType}
          pageType={pageType}
          oauthTokenHeader={oauthTokenHeader}
          siteUid={siteUid}
          pageUid={pageUid}
          setIsMetaUpdated={setIsMetaUpdated}
          pageContent={pageContent}
          setDeletePageData={setDeletePageData}
        />
      }
    </>
  );
}
